import React, { useState, useEffect } from "react";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import ProductH from "../../../images/product/h.png";
import Dropzone from "react-dropzone";
import SimpleBar from "simplebar-react";
import {
  Block,
  BlockHead,
  BlockTitle,
  BlockBetween,
  BlockHeadContent,
  Icon,
  Row,
  Col,
  Button,
  DataTableHead,
  DataTableBody,
  DataTableRow,
  DataTableItem,
  PaginationComponent,
} from "../../../components/Component";
import { Card, DropdownItem, UncontrolledDropdown, DropdownMenu, DropdownToggle, Badge } from "reactstrap";
import { useForm } from "react-hook-form";
import { Modal, ModalBody } from "reactstrap";
import { RSelect } from "../../../components/Component";
import { handleDeleteApis, handleGetApis } from "../../../service/Api";
import { useNavigate } from "react-router-dom";

const ProductList = () => {
  const [data, setData] = useState([]);
  const [filterDdata, setFilterData] = useState([]);
  const [sm, updateSm] = useState(false);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    img: null,
    sku: "",
    price: 0,
    salePrice: 0,
    stock: 0,
    category: [],
    fav: false,
    check: false,
  });
  const [editId, setEditedId] = useState();
  const [view, setView] = useState({
    edit: false,
    details: false,
  });
  const [onSearchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(7);
  const [files, setFiles] = useState([]);

  const fetchProduct = async () => {
      try {
        const result = await handleGetApis("admin/get/products");
        if (result.data.success) {
          setData(result.data.data)
          setFilterData(result.data.data)
        }
      } catch (err) {
        console.log(err);
      }
    };
useEffect(()=>{
  fetchProduct();
}, [])

  // Changing state value when searching name
  useEffect(() => {
    if (onSearchText !== "") {
      const filteredObject = data.filter((item) => {
        return item.name.toLowerCase().includes(onSearchText.toLowerCase());
      });
      setFilterData([...filteredObject]);
    } else {
      setFilterData([...data]);
    }
  }, [onSearchText]);

  const resetForm = () => {
    setFormData({
      name: "",
      img: null,
      sku: "",
      price: 0,
      salePrice: 0,
      stock: 0,
      category: [],
      fav: false,
      check: false,
    });
    reset({});
  };

  // function that loads the want to editted data
  const onEditClick = (id) => {
    navigate(`/edit-product?id=${id}`)
  };

  useEffect(() => {
    reset(formData)
  }, [formData]);

  // onChange function for searching name
  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };


  const deleteProduct = async (id) => {
    if (!window.confirm("Delete this product? It will be removed from the website too.")) return;
    const result = await handleDeleteApis(`admin/delete/product`, { id });
    // On failure the helper returns { message } instead of an axios response.
    if (!result?.data?.success) {
      alert(result?.data?.message || result?.message || "Failed to delete product");
      return;
    }
    alert(result.data.message);
    // Drop it from both lists, or clearing the search would bring it back.
    const keep = (item) => item.id !== id;
    setData((prev) => prev.filter(keep));
    setFilterData((prev) => prev.filter(keep));
  };

  // toggle function to view product details
  const toggle = (type) => {
    setView({
      edit: type === "edit" ? true : false,
      details: type === "details" ? true : false,
    });
  };

  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = filterDdata.slice(indexOfFirstItem, indexOfLastItem);

  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
   const hostUrl = process.env.REACT_APP_API_HOSTURL;
  const { register, handleSubmit, reset, formState: { errors } } = useForm();
  return <>
    <Head title="Product List"></Head>
    <Content>
      <BlockHead size="sm">
        <BlockBetween>
          <BlockHeadContent>
            <BlockTitle>Products</BlockTitle>
          </BlockHeadContent>
          <BlockHeadContent>
            <div className="toggle-wrap nk-block-tools-toggle">
              <a
                href="#more"
                className="btn btn-icon btn-trigger toggle-expand me-n1"
                onClick={(ev) => {
                  ev.preventDefault();
                  updateSm(!sm);
                }}
              >
                <Icon name="more-v"></Icon>
              </a>
              <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                <ul className="nk-block-tools g-3">
                  <li>
                    <div className="form-control-wrap">
                      <div className="form-icon form-icon-right">
                        <Icon name="search"></Icon>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        id="default-04"
                        placeholder="Quick search by name"
                        onChange={(e) => onFilterChange(e)}
                      />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </BlockHeadContent>
        </BlockBetween>
      </BlockHead>
      <Block>
        <Card className="card-bordered">
          <div className="card-inner-group">
            <div className="card-inner p-0">
              <DataTableBody>
                <DataTableHead>
                  <DataTableRow>
                    <span>Name</span>
                  </DataTableRow>
                  <DataTableRow>
                    <span>Price</span>
                  </DataTableRow>
                  <DataTableRow>
                    <span>MRP</span>
                  </DataTableRow>
                  <DataTableRow size="sm">
                    <span>Stock</span>
                  </DataTableRow>
                  <DataTableRow size="md">
                    <span>Feature</span>
                  </DataTableRow>
                  <DataTableRow size="md">
                    <span>Status</span>
                  </DataTableRow>
                  <DataTableRow className="nk-tb-col-tools text-end">
                    <span>Action</span>
                  </DataTableRow>
                </DataTableHead>
                {currentItems.length > 0
                  ? currentItems.map((item) => {
                    const primaryImg = item?.images?.find((k) => k?.is_primary === 1) || item?.images?.[0];
                    // Windows API hosts store "uploads\file.jpg"; no image → placeholder icon.
                    const mediaPath = primaryImg?.media_url?.replace(/\\/g, "/");
                    const image = mediaPath && (/^https?:\/\//.test(mediaPath) ? mediaPath : `${hostUrl}${mediaPath.startsWith("/") ? "" : "/"}${mediaPath}`);
                      return (
                        <DataTableItem key={item.id}>
                          <DataTableRow>
                            <span className="tb-product">
                              {image ? (
                                <img src={image} alt="product" className="thumb" />
                              ) : (
                                <div className="thumb bg-light d-flex align-items-center justify-content-center" style={{ width: 40, height: 40, borderRadius: 4 }}>
                                  <Icon name="img" className="text-soft" />
                                </div>
                              )}
                              <span className="title">{item.name}</span>
                            </span>
                          </DataTableRow>
                          <DataTableRow>
                            <span className="tb-sub">INR {item?.variants[0]?.price}</span>
                          </DataTableRow>
                          <DataTableRow>
                            <span className="tb-sub">INR {item?.variants[0]?.mrp}</span>
                          </DataTableRow>
                          <DataTableRow size="sm">
                            <span className="tb-sub">{item?.variants[0]?.stock}</span>
                          </DataTableRow>
                          <DataTableRow size="md">
                            <span className="tb-sub">
                              {item?.is_featured === 1 ? 'Active' : 'Not Active'}
                            </span>
                          </DataTableRow>
                          <DataTableRow size="md">
                            <span className="tb-sub">
                              {item?.is_active === 1 ? 'Active' : 'Not Active'}
                            </span>
                          </DataTableRow>
                          <DataTableRow className="nk-tb-col-tools text-end">
                            <ul className="nk-tb-actions gx-1 my-n1">
                              <li className="me-n1">
                                <UncontrolledDropdown>
                                  <DropdownToggle
                                    tag="a"
                                    href="#more"
                                    onClick={(ev) => ev.preventDefault()}
                                    className="dropdown-toggle btn btn-icon btn-trigger"
                                  >
                                    <Icon name="more-h"></Icon>
                                  </DropdownToggle>
                                  <DropdownMenu end>
                                    <ul className="link-list-opt no-bdr">
                                      <li>
                                        <DropdownItem
                                          tag="a"
                                          href="#media"
                                          onClick={(ev) => {
                                            ev.preventDefault();
                                            navigate(`/product-media?id=${item.id}`);
                                          }}
                                        >
                                          <Icon name="img"></Icon>
                                          <span>Manage Media</span>
                                        </DropdownItem>
                                      </li>
                                      <li>
                                        <DropdownItem
                                          tag="a"
                                          href="#edit"
                                          onClick={(ev) => {
                                            ev.preventDefault();
                                            onEditClick(item.id);
                                            toggle("edit");
                                          }}
                                        >
                                          <Icon name="edit"></Icon>
                                          <span>Edit Product</span>
                                        </DropdownItem>
                                      </li>
                                      <li>
                                        <DropdownItem
                                          tag="a"
                                          href="#remove"
                                          onClick={(ev) => {
                                            ev.preventDefault();
                                            deleteProduct(item.id);
                                          }}
                                        >
                                          <Icon name="trash"></Icon>
                                          <span>Remove Product</span>
                                        </DropdownItem>
                                      </li>
                                    </ul>
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              </li>
                            </ul>
                          </DataTableRow>
                        </DataTableItem>
                      );
                    })
                  : null}
              </DataTableBody>
              <div className="card-inner">
                {data.length > 0 ? (
                  <PaginationComponent
                    itemPerPage={itemPerPage}
                    totalItems={data.length}
                    paginate={paginate}
                    currentPage={currentPage}
                  />
                ) : (
                  <div className="text-center">
                    <span className="text-silent">No products found</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Card>
      </Block>
    </Content>
  </>;
};

export default ProductList;
